import { z } from "zod";

// =====================================
// Job Run Trends
// =====================================
export const JobRunTrendPointSchema = z.object({
  period: z.string(),
  total_runs: z.number().default(0),
  successful_runs: z.number().default(0),
  failed_runs: z.number().default(0),
  avg_duration_seconds: z.number().default(0),
  estimated_cost_usd: z.number().nullable().optional(),
  // DBU-side cost for the "Costs" stacked-bar mode.
  dbu_cost: z.number().default(0),
  // Cloud-provider cost is not ingested yet, so this is `null`.
  cloud_cost: z.number().nullable().optional(),
});

export const JobRunTrendsResponseSchema = z.object({
  trends: z.array(JobRunTrendPointSchema),
  granularity: z.string(),
});

export type JobRunTrendPoint = z.infer<typeof JobRunTrendPointSchema>;
export type JobRunTrendsResponse = z.infer<typeof JobRunTrendsResponseSchema>;

export interface JobRunTrendsParams {
  start_date: string;
  end_date: string;
  granularity?: "day" | "month";
  workspace_id?: string;
}

// =====================================
// Jobs Summary (hero cost cards)
// =====================================
export const JobsSummaryResponseSchema = z.object({
  total_cost: z.number().default(0),
  total_dbu_cost: z.number().default(0),
  // `null` → FE renders a "-" placeholder.
  total_cloud_cost: z.number().nullable().optional(),
  total_realized_savings: z.number().default(0),
});

export type JobsSummaryResponse = z.infer<typeof JobsSummaryResponseSchema>;

export interface JobsSummaryParams {
  start_date: string;
  end_date: string;
  workspace_id?: string;
}

// =====================================
// Per-job cost trends ("Jobs" chart mode)
// =====================================
export const JobCostTrendPointSchema = z.object({
  period: z.string(),
  job_name: z.string(),
  total_dbus: z.number().default(0),
  estimated_cost_usd: z.number().default(0),
});

export const JobCostTrendsResponseSchema = z.object({
  trends: z.array(JobCostTrendPointSchema),
  job_names: z.array(z.string()).default([]),
  granularity: z.string(),
  total_cost: z.number().default(0),
});

export type JobCostTrendPoint = z.infer<typeof JobCostTrendPointSchema>;
export type JobCostTrendsResponse = z.infer<typeof JobCostTrendsResponseSchema>;

export interface JobCostTrendsParams {
  start_date: string;
  end_date: string;
  granularity?: "day" | "month";
  workspace_id?: string;
}
